import { useCallback, useContext, useEffect, useRef } from 'react';
import { LinkContext, LinkDispatchContext } from '@trinity/chat-components/components/BrandInsights/context';
import { ActiveChatSessionContext } from '@trinity/chat-components/components/Chat/context';
import { useIsFullPageChat } from '@trinity/chat-components/components/Chat/hooks/useIsFullPageChat';
import { ChatHistoryManagerContext } from '@trinity/chat-components/components/Chat.History/context';
import { useLoadChatInstance } from '@trinity/chat-components/components/Chat.History/hooks/index';
import { FullScreenChatBasePathContext } from './contexts';
import { useLocation, useNavigate } from './RoutingProvider';

export function useMonitorChatIdentifier() {
  const initializedIdentifier = useRef<string>(null);

  const link = useContext(LinkContext);
  const dispatch = useContext(LinkDispatchContext);
  const historyManager = useContext(ChatHistoryManagerContext);
  const location = useLocation();
  const session = useContext(ActiveChatSessionContext);
  const navigate = useNavigate();

  const handleChatLoaded = useCallback(() => {
    dispatch({
      type: 'update-chat-initialized',
      payload: {
        error: false,
      },
    });
    //try settting brand here
  }, [dispatch]);

  const handleChatLoadError = useCallback(() => {
    dispatch({
      type: 'state-reset',
      payload: {
        chatIdentifier: null,
        initialized: true,
        error: false,
      },
    });
  }, [dispatch]);

  const loadChat = useLoadChatInstance({
    onError: handleChatLoadError,
    onSuccess: handleChatLoaded,
  });

  const isFullPageChat = useIsFullPageChat();
  const fullScreenChatPath = useContext(FullScreenChatBasePathContext);

  // Updates the url to reflect the active session's chat identifier
  useEffect(() => {
    if (session?.identifier && link.initialized) {
      // console.log('Session updated, redirecting to chat', session.identifier);
      if (isFullPageChat) {
        navigate({
          pathname: `${fullScreenChatPath}/${session.identifier}`,
          search: location.search,
        }, {
          replace: true,
        });
      } else {
        // history.replace(location.pathname + '#bi:ocid:' + session.identifier);
      }
    }
  }, [fullScreenChatPath, isFullPageChat, navigate, location.pathname, location.search, link?.initialized, session?.identifier]);

  // Loads chat instance one time from the first chat identifier
  useEffect(() => {
    if (!historyManager?.initialized || !link.chatIdentifier) return;

    if (!initializedIdentifier.current || initializedIdentifier.current !== link.chatIdentifier) {
      initializedIdentifier.current = link.chatIdentifier;

      loadChat(link.chatIdentifier);
    }
  }, [
    loadChat,
    historyManager?.initialized,
    link.chatIdentifier,
  ]);
}